<div class="flex justify-center" *ngIf="isEmailVerified === EmailVerificationState.LOADING">
    <div class="w-1/4">
        <div class="mb-5 mt-5 h-3 w-full overflow-hidden rounded-full bg-gray-200">
            <div class="h-full bg-blue-500 progress-striped progress-animated" style="width: 100%" role="progressbar" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100">
                <span class="flex items-center justify-center text-xs font-semibold text-white h-full"></span>
            </div>
        </div>
        <span class="flex items-center justify-center"><small> Loading... </small></span>
    </div>
</div>    
<div class="flex justify-center" *ngIf="isEmailVerified === EmailVerificationState.SUCCESS">
    <div class="w-1/3">
        <div class="my-5 p-5 border rounded shadow-lg">
            <div class="text-center">
                <div class="flex justify-center mb-2">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#198754" class="size-6">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                    </svg>    
                </div>
                <div class="mb-2">
                    Your email-address updated successfully!
                </div>
                <div class="mt-4">
                    <button routerLink="/" class="bg-black text-white font-medium py-2.5 px-8 rounded-xl hover:bg-gray-800 transition-colors cursor-pointer">
                        Go To Home
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="flex justify-center" *ngIf="isEmailVerified === EmailVerificationState.ERROR">
    <div class="w-1/3">
        <div class="my-5 p-5 border rounded shadow-lg">
            <div class="text-center">
                <div class="flex justify-center mb-2">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#dc3545" class="size-6">
                        <path stroke-linecap="round" stroke-linejoin="round" d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                    </svg>
                </div>
                <div class="mb-2">
                    Your email-address verification failed!. Please try again.
                </div>
                <div class="text-red-500" *ngIf="error_message"> {{ error_message }} </div>
                <div class="mt-4">
                    <button routerLink="/" class="bg-black text-white font-medium py-2.5 px-8 rounded-xl hover:bg-gray-800 transition-colors cursor-pointer">
                        Go To Home
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="flex justify-center" *ngIf="isEmailVerified === EmailVerificationState.WEB2_AUTH_ERROR">
    <div class="w-1/3">
        <div class="my-5 p-5 border rounded shadow-lg">
            <div class="text-center">
                <div class="flex justify-center mb-2">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#dc3545" class="size-6">
                        <path stroke-linecap="round" stroke-linejoin="round" d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                    </svg>
                </div>
                <div class="mb-2">
                    Login attempt failed. Please try again.
                </div>
                <div class="mt-4">
                    <button routerLink="/" class="bg-black text-white font-medium py-2.5 px-8 rounded-xl hover:bg-gray-800 transition-colors cursor-pointer">
                        Go To Home
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>